import React from 'react';
import { Image as ImageIcon, Video, FileText, Music } from "lucide-react";
import { HARDCODED_MEDIA } from '../../../utils/hardcodedMediaConfig';

const mediaConfigs = {
  image: {
    icon: ImageIcon,
    placeholderText: 'Image placeholder',
    hasPreview: true,
    previewHeight: 'h-40',
    iconSize: 'h-10 w-10',
    spacing: 'mb-2'
  },
  video: {
    icon: Video,
    placeholderText: 'Video placeholder',
    hasPreview: true,
    previewHeight: 'h-40',
    iconSize: 'h-10 w-10',
    spacing: 'mb-2'
  },
  document: {
    icon: FileText,
    placeholderText: 'Document',
    hasPreview: false,
    previewHeight: 'h-20',
    iconSize: 'h-8 w-8',
    spacing: 'mb-1'
  },
  audio: {
    icon: Music,
    placeholderText: 'Audio',
    hasPreview: false,
    previewHeight: 'h-20',
    iconSize: 'h-8 w-8',
    spacing: 'mb-1'
  }
};

const MediaPreview = ({ type = 'none', preview = '', mode = 'create' }) => {
  const config = mediaConfigs[type];
  if (!config) return null;

  const IconComponent = config.icon;

  if (config.hasPreview && preview) {
    return type === 'image' ? (
      <img
        src={preview}
        alt="Header content preview"
        className="w-full h-auto object-cover max-h-60"
      />
    ) : (
      <video
        src={preview}
        className="w-full h-auto object-cover max-h-60"
        controls
      />
    );
  }

  if (mode === 'send' && (type === 'image' || type === 'video')) {
    return (
      <div className={`w-full ${config.previewHeight} flex items-center justify-center`}>
        <div className="text-center">
          <IconComponent
            className={`${config.iconSize} mx-auto text-gray-300 dark:text-gray-600 ${config.spacing}`}
          />
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {config.placeholderText}
          </p>
        </div>
      </div>
    );
  }

  if (type === 'image') {
    return (
      <img
        src={HARDCODED_MEDIA.image.preview}
        alt="Default header visual"
        className="w-full h-auto object-cover max-h-60"
      />
    );
  }

  if (type === 'video') {
    return (
      <video
        src={HARDCODED_MEDIA.video.preview}
        className="w-full h-auto object-cover max-h-60"
        controls
      />
    );
  }

  return (
    <div className={`w-full ${config.previewHeight} flex items-center justify-center`}>
      <div className="text-center">
        <IconComponent
          className={`${config.iconSize} mx-auto text-gray-300 dark:text-gray-600 ${config.spacing}`}
        />
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {config.placeholderText}
        </p>
      </div>
    </div>
  );
};

export default MediaPreview;
